'use strict';

angular.module('shiftTraderApp')
    .directive('saDepartmentEditor', function () {
      return {
        templateUrl: 'views/directives/saDepartmentEditor.html',
        restrict: 'A',
        scope: {
          me:'=loggedInUser',
          org:'=',
          allDepartments: '=departments'
        },
        controller: ['$scope', 'Departments', 'toastr', function($scope, Departments, toastr) {
          $scope.newDepartmentData = {
            name: '',
            description: ''
          };

          $scope.toggleDepartmentEditable = function(dept) {
            if (dept._editable) {
              if (!dept._modified) {
                dept._editable = false;
              }
            } else {
              dept._editable = true;
            }
          };

          $scope.createDepartment = function() {
            var data = {
              organization_id: $scope.org.id
            };
            angular.extend(data, $scope.newDepartmentData);
            Departments.create(data)
                .then(function(data) {
                  data._modified = false;
                  data._editable = false;
                  $scope.allDepartments.push(data);
                  $scope.newDepartmentData.name = '';
                  $scope.newDepartmentData.default_hourly_wage = '';
                  toastr.success('Department ' + data.name + ' created.', 'Success');
                }, function() {
                  toastr.error('Department ' + data.name + ' creation failed. Try again later.', 'Error');
                });
          };

          $scope.saveDepartment = function(dept) {
            dept.$update({name: dept.name, description: dept.description})
                .then(function() {
                  dept._editable = false;
                  dept._modified = false;
                  dept.department = _.find($scope.org.departments, {id: dept.department_id});
                  toastr.success('Department ' + dept.name + ' updated.', 'Success');
                }, function() {
                  toastr.error('Department ' + dept.name + ' update failed. Try again later.', 'Error');
                });
          };

          $scope.setDepartmentInactive = function(dept) {
            dept.$makeInactive()
                .then(function() {
                  dept._editable = false;
                  toastr.success('Department ' + dept.name + ' made inactive.', 'Success');
                }, function() {
                  toastr.error('Request to set department ' + dept.name + ' inactive failed. Try again later.', 'Error');
                });
          };

          $scope.setDepartmentActive = function(dept) {
            dept.$makeActive()
                .then(function() {
                  dept._editable = false;
                  toastr.success('Department ' + dept.name + ' made active.', 'Success');
                }, function() {
                  toastr.error('Request to set department ' + dept.name + ' active failed. Try again later.', 'Error');
                });
          };

        }]
      };
    });
